/* AMOR "zestaw z pokoju" (sections/am-zestawy, homepage). Rooms -> cards -> panels, dots <-> rows, live total.
   Loaded with defer at the end of the section, so the markup is there; a section reloaded in the theme editor is
   picked up through shopify:section:load. */
(function () {
  if (window.amZs) { window.amZs(); return; }
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  function ev(n) { if (window.amClarity && window.amClarity.event) window.amClarity.event(n); }
  function tag(k, v) { if (window.amClarity && window.amClarity.tag) window.amClarity.tag(k, v); }
  /* i18n (snippets/am-i18n): strings in the page's language, amounts in another currency than złoty, the market's
     free-delivery threshold (Czech market: 0, always free); the Polish text is the fallback. */
  function T(k, d) { var v = (window.AMOR_I18N || {})[k]; return typeof v === 'string' && v ? v : d; }
  function F(s, o) { return String(s).replace(/\{(\w+)\}/g, function (m, k) { return o[k] != null ? o[k] : m; }); }
  var FREE = window.AMOR_MKT && window.AMOR_MKT.free != null ? Number(window.AMOR_MKT.free) : 100000;
  /* grosze -> "3.537,40 zł" (whole złoty without ",00"), the shop's money format */
  function fmt(v) { var x = window.AMOR_MONEY ? window.AMOR_MONEY(v) : null; if (x != null) return x; v = Math.round(v); var z = Math.floor(v / 100), g = v % 100; return z.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') + (g ? ',' + (g < 10 ? '0' : '') + g : '') + ' zł'; }
  function meble(n) { var f = (window.AMOR_I18N || {}).plural_mebel; if (f && typeof f === 'object' && window.AMOR_PLURAL) return window.AMOR_PLURAL(n, f); var d = n % 10, h = n % 100; return n === 1 ? 'mebel' : (d > 1 && d < 5 && (h < 12 || h > 14)) ? 'meble' : 'mebli'; }

  function initForm(f) {
    if (f.hasAttribute('data-zs-on')) return;
    f.setAttribute('data-zs-on', '');
    var btn = f.querySelector('[data-zs-add]'), cnt = f.querySelector('[data-zs-count]'), sub = f.querySelector('[data-zs-sub]'),
      deal = f.querySelector('[data-zs-deal]'), save = f.querySelector('[data-zs-save]'), hint = f.querySelector('[data-zs-hint]'),
      tot = f.querySelector('[data-zs-total]'), all = f.querySelector('[data-zs-all]');
    var cbs = [].slice.call(f.querySelectorAll('.am-zs__cb'));
    /* Mirrors the automatic discount: 3+ pieces of furniture -5% on those pieces (data-set="0" neither counts nor gets it). */
    function paint() {
      var s = 0, n = 0, m = 0, ms = 0;
      cbs.forEach(function (c) { if (!c.checked) return; var v = +c.dataset.price; s += v; n++; if (c.dataset.set !== '0') { m++; ms += v; } });
      var p = m > 2 ? 5 : 0, sv = Math.round(ms * p / 100), after = s - sv;
      cnt.textContent = n ? F(T('zs_selected', 'Zaznaczone: {n} {word}'), { n: n, word: meble(n) }) : T('zs_none', 'Nic nie zaznaczono');
      cnt.parentNode.hidden = !n;
      tot.parentNode.hidden = !n;
      sub.textContent = n ? fmt(s) : '';
      deal.hidden = !p;
      save.textContent = p ? '−' + fmt(sv) : '';
      hint.textContent = p ? (after >= FREE ? T('set_free', 'Dostawa gratis.') : '') :
        m === 2 ? T('zs_third', 'Zaznacz trzeci mebel, a zapłacisz za meble 5% mniej.') :
        m === 1 ? T('zs_two_more', 'Zaznacz jeszcze 2 meble, a zapłacisz za meble 5% mniej.') : T('zs_hint0', 'Kup 3 meble lub więcej i zapłać za nie 5% mniej.');
      hint.hidden = !hint.textContent;
      tot.textContent = fmt(after);
      btn.disabled = !n;
      btn.textContent = n ? F(T('zs_add_n', 'Dodaj {n} {word} do koszyka'), { n: n, word: meble(n) }) : T('zs_pick', 'Zaznacz meble, które chcesz kupić');
      if (all) all.textContent = n && n === cbs.length ? T('zs_unselect_all', 'Odznacz wszystkie') : T('zs_select_all', 'Zaznacz wszystkie');
    }
    f.addEventListener('change', function (e) {
      var sel = e.target.closest && e.target.closest('[data-zs-var]');
      if (sel) {
        var o = sel.options[sel.selectedIndex], row = sel.closest('.am-zs__row'), cb = row.querySelector('.am-zs__cb'), pr = row.querySelector('[data-zs-price]');
        cb.value = o.value; cb.dataset.price = o.dataset.price; cb.dataset.set = o.dataset.set;
        if (pr) pr.innerHTML = (+o.dataset.cmp > +o.dataset.price ? '<s>' + fmt(+o.dataset.cmp) + '</s>' : '') + fmt(+o.dataset.price);
        var im = o.dataset.img && row.querySelector('.am-zs__th img');
        if (im) { im.removeAttribute('srcset'); im.src = o.dataset.img; }
      }
      paint();
    });
    if (all) all.addEventListener('click', function () {
      var on = !cbs.every(function (c) { return c.checked; });
      cbs.forEach(function (c) { c.checked = on; });
      paint();
    });
    btn.addEventListener('click', function () { ev('zestaw_do_koszyka'); });
    paint();
  }

  /* A dot and its row light up together; a dot brings its row into view. */
  function initPanel(p) {
    function hot(n, scroll) {
      p.querySelectorAll('[data-zs-dot]').forEach(function (d) { d.classList.toggle('is-hot', d.getAttribute('data-zs-dot') === n); });
      p.querySelectorAll('[data-zs-row]').forEach(function (r) {
        var on = r.getAttribute('data-zs-row') === n;
        r.classList.toggle('is-hot', on);
        if (on && scroll) {
          var b = r.getBoundingClientRect();
          if (b.top < 0 || b.bottom > window.innerHeight) r.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' });
          var cb = r.querySelector('.am-zs__cb');
          if (cb) cb.focus({ preventScroll: true });
        }
      });
    }
    p.addEventListener('click', function (e) {
      var d = e.target.closest('[data-zs-dot]');
      if (d) hot(d.getAttribute('data-zs-dot'), true);
    });
    p.querySelectorAll('[data-zs-row]').forEach(function (r) {
      var n = r.getAttribute('data-zs-row');
      r.addEventListener('pointerenter', function () { hot(n, false); });
      r.addEventListener('focusin', function () { hot(n, false); });
    });
    var f = p.querySelector('[data-zs-form]');
    if (f) initForm(f);
  }

  function init(root) {
    if (root.hasAttribute('data-zs-on')) return;
    root.setAttribute('data-zs-on', '');
    var panels = [].slice.call(root.querySelectorAll('[data-zs-panel]'));
    var rooms = [].slice.call(root.querySelectorAll('[data-zs-room]'));
    var rows = [].slice.call(root.querySelectorAll('[data-zs-cards]'));
    var cards = [].slice.call(root.querySelectorAll('[data-zs-k]'));
    panels.forEach(initPanel);
    var cur = panels.filter(function (p) { return !p.hidden; })[0];
    function show(k) {
      var next = root.querySelector('[data-zs-panel="' + k + '"]');
      if (!next) return;
      if (next !== cur) {
        if (cur) cur.hidden = true;
        /* Photos parked by snippets/am-defer-img (15.10.2026) get their srcset back before the panel shows. */
        if (window.amWake) window.amWake(next);
        next.hidden = false;
        next.classList.remove('is-in');
        void next.offsetWidth;
        next.classList.add('is-in');
        cur = next;
        tag('kolekcje_kolor', next.getAttribute('data-h'));
      }
      cards.forEach(function (c) { var on = c.getAttribute('data-zs-k') === String(k); c.classList.toggle('is-on', on); c.setAttribute('aria-current', on ? 'true' : 'false'); });
    }
    function room(r) {
      rooms.forEach(function (b) { var on = b.getAttribute('data-zs-room') === r; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      var row = null;
      rows.forEach(function (w) { var on = w.getAttribute('data-zs-cards') === r; w.classList.toggle('is-on', on); if (on) row = w; });
      if (!row) return;
      if (window.amWake) window.amWake(row);
      /* keep the collection when it is in this room too (AURO: living room and bedroom), else the room's first */
      var k = null, first = row.querySelector('[data-zs-k]');
      if (cur && row.querySelector('[data-zs-k="' + cur.getAttribute('data-zs-panel') + '"]')) k = cur.getAttribute('data-zs-panel');
      else if (first) k = first.getAttribute('data-zs-k');
      if (k != null) show(k);
      row.scrollLeft = 0;
    }
    rooms.forEach(function (b) { b.addEventListener('click', function () { room(b.getAttribute('data-zs-room')); }); });
    cards.forEach(function (c) {
      c.addEventListener('click', function (e) {
        /* Ctrl/Cmd/Shift-click still opens the collection, like any link. */
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button) return;
        e.preventDefault();
        show(c.getAttribute('data-zs-k'));
      });
      /* a card under the pointer or finger starts loading its panel's photo before the tap lands */
      function warm() {
        var p = root.querySelector('[data-zs-panel="' + c.getAttribute('data-zs-k') + '"]');
        if (!p || p.hasAttribute('data-warm')) return;
        p.setAttribute('data-warm', '');
        p.querySelectorAll('img').forEach(function (im) { im.loading = 'eager'; });
        if (window.amWake) window.amWake(p);
      }
      c.addEventListener('pointerenter', warm, { passive: true });
      c.addEventListener('touchstart', warm, { passive: true });
      c.addEventListener('focus', warm);
    });
  }

  window.amZs = function () { document.querySelectorAll('[data-am-zs]').forEach(init); };
  window.amZs();
  document.addEventListener('shopify:section:load', window.amZs);
  document.addEventListener('shopify:block:select', function (e) {
    var root = e.target && e.target.closest && e.target.closest('[data-am-zs]');
    var c = e.target && e.target.closest && e.target.closest('[data-zs-k]');
    if (root && c) c.click();
  });
})();